import React from "react"
import { PropertyView } from "../../components/molecules/properties-view";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';
import { InfoLabel } from "./softwareVersions/infoLabel";


type Reported = {
    softwareVersion?: string,
    liquidState?: "good" | "low" | "empty" | undefined,
}

export type MachineDetails = {
    id: string,
    machineName: string,
    serialNumber: string,
    deviceId: string,
    reported?: Reported,
    connectionState: string,
    cyclesCount: number,
    nodeId: string | undefined,
    nodeName: string | undefined,
    parents: Array<{
        id: string,
        name: string
    }>,
    tags: Array<{ tag: string, colorCode: string }>,
    description: string,
    articleNumber?: string
    targetedSwVersion?: string
    location?: {
        latitude: number,
        longitude: number
    },
    monitored: boolean,
    machineErrors: Array<{
        name: string,
        text: string,
        code: number,
        blocking: boolean,
        reportedAt: string,
        displayError: boolean
    }>
}



export const MachineDetailsView = ({
    ownerCompanyName,
    ownerCompanyId,
    nodeName,
    nodeUrl,
    machineDetails
}: {
    ownerCompanyName: string | undefined,
    ownerCompanyId: string | undefined,
    nodeName: string | undefined,
    nodeUrl: string | undefined,
    machineDetails: MachineDetails | undefined

}): React.ReactElement => {

    const owner = (ownerCompanyName && ownerCompanyId) ? <Link style={{ flex: 1 }} component={RouterLink} to={`/customers/${ownerCompanyId}`}>{ownerCompanyName}</Link> : <Typography style={{ flex: 1 }} variant='body1'>{'Nobody'}</Typography>
    const store = (nodeUrl ? <Link sx={{ flex: 1 }} component={RouterLink} to={nodeUrl}>{nodeName}</Link> : <Typography style={{ flex: 1 }} variant='body1'>{'Not in any store'}</Typography>)

    console.log("Min maskindata ser ut så här:", machineDetails);
    return (
      <PropertyView
        Values={[
          { Label: "Serial Id:", Path: "serialNumber" },
          { Label: "Store:", ValueComponent: store },
          { Label: "Owner:", ValueComponent: owner },
          { Label: "Total run cycles:", Path: "cyclesCount" },
          { Label: "SW Serial Id:", Path: "deviceId" },
          { Label: "Current SW Version:", Path: "reported.softwareVersion" },
          {
            Label: (
              <InfoLabel
                text="Targeted SW Version:"
                tooltip="This is the software version that can be expected on this machine after a software update."
              />
            ),
            Path: "targetedSwVersion",
          },
          { Label: "HW Article Number:", Path: "articleNumber" },
        ]}
        Data={machineDetails}
      />
    );
}

